import { Box, Tabs } from '@mui/material'
import React from 'react'

import { makeStyles } from 'tss-react/mui'
import LinkedTooltipTab from './LinkedTooltipTab'

type TabDataBattery = {
  storageSerialNo: string
  batteryIndex: string
}

export interface TabsBarTab {
  onClick?: () => void
  label: string | React.ReactNode
  icon?: React.ReactNode
  disabled?: boolean
  disabledTooltipText?: string
  href?: string
  doDisplay?: boolean
  data?: TabDataBattery
  hasDisabledStyleAlways?: boolean
  component?: React.ReactElement
  componentHref?: string /* link to component necessary for url params */
  dataQa?: string
  id?: string
}

interface TabsBarProps {
  activeTab: number
  tabs: TabsBarTab[]
}

const useStyles = makeStyles()(theme => ({
  tabs: {
    height: 30,
    display: 'flex',
    alignItems: 'end',
    overflow: 'visible',
    '& .MuiTabs-scroller': {
      borderBottom: `1px solid ${theme.palette.grey.grey06}`,
    },
    '& .MuiTab-root:first-of-type, .MuiTabs-indicator:first-of-type': {
      marginLeft: 0,
    },
    '& .MuiTabScrollButton-root, .MuiTabScrollButton-horizontal': {
      width: 12,
      paddingBottom: theme.spacing(1),
      [theme.breakpoints.down('md')]: {
        borderBottom: `1px solid ${theme.palette.grey.grey06}`,
        transition: 'opacity 0.3s ease',
        '&.Mui-disabled': {
          opacity: 1,
          transition: 'opacity 0.3s ease',
          svg: {
            opacity: 0.2,
          },
        },
      },
    },
    '& .MuiTabs-flexContainer': {
      gap: theme.spacing(2),
    },
  },
}))

const TabsBar: React.FC<TabsBarProps> = ({ activeTab, tabs }) => {
  const { classes } = useStyles()

  return (
    <Box sx={{ width: '100%' }}>
      <Tabs className={classes.tabs} value={Math.max(activeTab, 0)} variant={'scrollable'} allowScrollButtonsMobile scrollButtons={'auto'}>
        {tabs.map((tab, index) => {
          return (
            <LinkedTooltipTab
              key={`${tab.label}-${index}`}
              id={`app-header-tab-${tab.id}`}
              label={tab.label}
              disabledTooltipText={tab.disabledTooltipText}
              disabled={tab.disabled}
              onClick={tab.onClick}
              href={tab.href}
              isActive={index === activeTab}
              hasDisabledStyleAlways={tab.hasDisabledStyleAlways}
              dataQa={tab.dataQa}
            />
          )
        })}
      </Tabs>
    </Box>
  )
}

export default TabsBar
